import { useState } from 'react';
import '~/apps/App.css';
import '~/apps/common.css';
import {useSnackbar} from 'notistack';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import MapDialog from "~/components/MapDialog.js";
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import RoomIcon from '@mui/icons-material/Room';

function LocalHits({hits, hitsPerPage, updateHitsPerPage, locations}) {

    const {enqueueSnackbar} = useSnackbar();

    const [mapDialogOpen, setMapDialogOpen] = useState(false);
    const [activeMapLocation, setActiveMapLocation] = useState({});

    const handleLoadMore = () => {
        updateHitsPerPage(Number(hitsPerPage) + 10);
    };

    const handleLoadAll = () => {
        updateHitsPerPage(2000);
    };

    const findLocation = address => {
        address = address.trim();
        const firstIndexOfSpace = address.indexOf(" ");
        if (firstIndexOfSpace !== -1) {
            address = address.substring(0, firstIndexOfSpace);
        }
        return locations.find(location => location.abbr === address);
    };

    const getBuildingName = address => {
        const foundLocation = findLocation(address);
        if (foundLocation)
            return foundLocation.name;
        return address;
    };

    const handleOpenMapDialog = address => {
        const foundLocation = findLocation(address);

        if (foundLocation) {
            setMapDialogOpen(true);
            setActiveMapLocation(foundLocation);
        } else
            enqueueSnackbar('Location not found.', {
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                },
            });
    };

    let hitsPerPageControl;
    let displayedHits = hits;

    const pageFooter = <div className="directorysearch-footer-text">
        NOTICE: This campus directory has been compiled for the use and convenience of the faculty and staff of
        San Francisco State University and others dealing with SF State. Neither this directory nor the information
        contained herein may be used, rented, distributed, or sold for commercial purposes in accordance with the
        California Information Practices Act. For more information, see
        <a
            href="https://adminfin.sfsu.edu/online-directories"
            target="_blank"
            rel="noreferrer"
        >
            the SF State Online Directories Practice Directive<span className="sr-only">&nbsp;(new window will open)</span>
        </a>.
    </div>;

    if (hitsPerPage < hits.length) {
        displayedHits = hits.slice(0, hitsPerPage);
        hitsPerPageControl = <Grid container spacing={2}>
            <Grid size={{xs: 12, md: 1}}/>
            <Grid size={{xs: 12, md: 5}} className="center-text">
                <Button
                    name="loadmore"
                    variant="contained"
                    size="large"
                    className="hits-button"
                    onClick={handleLoadMore}
                    color="secondary"
                >
                    Load 10 more
                </Button>
            </Grid>
            <Grid size={{xs: 12, md: 5}} className="center-text">
                <Button
                    name="loadall"
                    variant="contained"
                    size="large"
                    className="hits-button"
                    onClick={handleLoadAll}
                    color="secondary"
                >
                    Load all listings
                </Button>
            </Grid>
            <Grid size={{xs: 12, md: 1}}/>
        </Grid>;
    }

    let extra;

    return displayedHits.length > 0 ?
        <>
            <MapDialog
                open={mapDialogOpen}
                activeMapLocation={activeMapLocation}
                onCancel={() => {
                    setMapDialogOpen(false);
                }}
            />

            <ul className="list-style-none search-result">
                {displayedHits.map(hit => {
                    extra = 0;

                    if (!(hit.phone && hit.phone.trim())) {
                        extra++;
                    }
                    if (!(hit.email_addr && hit.email_addr.trim())) {
                        extra++;
                    }
                    if (!(hit.email_addr && hit.email_addr.trim())) {
                        extra++;
                    }

                    return <li key={hit.objectID} className="directorysearch-list-item">
                        <h3 aria-label="Name">
                            {hit.first_name && hit.first_name.trim() ? hit.first_name : ""}{" "}
                            {hit.middle_name && hit.middle_name.trim() ? hit.middle_name : ""}{" "}
                            {hit.last_name && hit.last_name.trim() ? hit.last_name : ""}{" "}
                            {hit.name_suffix && hit.name_suffix.trim() ? ", " + hit.name_suffix : ""}
                        </h3>

                        <div>
                            {hit.positions.map((position, index) => (
                                <span key={hit.objectID + index} aria-label="Title and Department">
                                    {(position.csu_working_title && position.csu_working_title.trim()) ? hit.positions[index].csu_working_title : ""} {(["3225", "3325", "3365", "3405", "3470", "3550", "3720"].includes(position.sfo_divcoll_num) && position.dept_title && position.dept_title.trim()) ? ", " + hit.positions[index].dept_title : ""} {position.sfo_divcoll_name && position.sfo_divcoll_name.trim() ? ", " + hit.positions[index].sfo_divcoll_name : ''}
                                    <br/>
                                </span>
                            ))}
                            <Grid container sx={{paddingTop: "8px", paddingBottom: "8px"}} spacing={1}>
                                {hit.phone && hit.phone.trim() ?
                                    <Grid size={{xs: 12, sm: 4 + extra}}>
                                        <a
                                            href={"tel:" + hit.phone.replace("(","").replace(")","").replace(" ","-")}
                                            className="link-icon" aria-label={"Phone Number: " + hit.phone}
                                        >
                                            <PhoneIcon fontSize="small" className="directorysearch-icon"/>
                                            <strong>{hit.phone}</strong>
                                        </a>
                                    </Grid> : null
                                }

                                {hit.email_addr && hit.email_addr.trim() ?
                                    <Grid size={{xs: 12, sm: 5 + extra}}>
                                        <a
                                            href={"mailto:" + hit.email_addr}
                                            aria-label={"Email Address: " + hit.email_addr}
                                        >
                                            <EmailIcon fontSize="small" className="directorysearch-icon"/>
                                            {hit.email_addr ? hit.email_addr : ''}
                                        </a>
                                    </Grid> : null
                                }

                                {hit.sfo_office_locatn && hit.sfo_office_locatn.trim() ?
                                    <Grid size={{xs: 12, sm: 3 + extra}}>
                                        <a
                                            onClick={() => handleOpenMapDialog(hit.sfo_office_locatn)}
                                            href="#"
                                            className={"link-icon"}
                                            aria-label={"Location: " + hit.sfo_office_locatn}
                                            title="Open Map"
                                        >
                                            <RoomIcon fontSize="small" className="directorysearch-icon"/>
                                            <abbr title={getBuildingName(hit.sfo_office_locatn)}>
                                                {hit.sfo_office_locatn}
                                            </abbr>
                                        </a>
                                    </Grid> : null
                                }
                            </Grid>
                        </div>
                    </li>
                })}
            </ul>
            {hitsPerPageControl}
            {pageFooter}
        </> : null;
}

export default LocalHits;
